import styled, { css } from 'styled-components';
import { colors } from 'stylesheets';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100vh;
  width: 10.5vw;
  margin-left: 20px;
  padding-top: 40px;
  border-right: 1px solid ${colors.greyLighter};
`;

export const ContentTask = styled.div`
  background: ${({ isActive }) => (isActive ? '#FBFBFB' : 'none')};
  box-shadow: ${({ isActive }) => (isActive
    ? '0px -1px 0px #EBEBEB, 0px 1px 0px #EBEBEB, -1px 0px 0px #EBEBEB, -4px 4px 4px rgba(239, 234, 234, 0.51)'
    : 'none')};
  border-radius: ${({ isActive }) => isActive && '5px 0px 0px 5px'};
  width: 100%;
  border-top: ${({ isActive }) => isActive && `1px solid ${colors.greyLighter}`};
  border-left: ${({ isActive }) => isActive && `1px solid ${colors.greyLighter}`};
  border-bottom: ${({ isActive }) => isActive && `1px solid ${colors.greyLighter}`};
  max-width: 170px;
  height: calc((100vh - 65px) / 5);
  min-height: 100px;
  max-height: 115px;
  margin-bottom: 20px;
  cursor: ${({ isActive }) => (isActive ? 'default' : 'pointer')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 20px;
  ${({ isActive }) => !isActive
    && `&:hover {
    background: #f4f4f4;
    border-radius: 4px 0px 0px 4px;
  }`}

  ${({ isActive }) => isActive
    && css`
      margin-right: -1px;
      z-index: 2;
    `};
`;

export const TotalStatus = styled.p`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: ${({ isActive, color }) => (isActive ? color : '#565656')};
  text-align: center;
`;

export const StatusName = styled.p`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  width: 80px;
  height: 30px;
  color: ${({ isActive, color }) => (isActive ? color : '#565656')};
  margin-bottom: 10px;
`;
